import React from "react";
import { Link } from "react-router-dom";
import FontAwesome from "react-fontawesome";

const RenderDevice = ({
  lastBookElementRef,
  list,
  snackMessage,
  handleOnClick,
  handleClick,
}) => {
// console.log(list);

  if (!list) return;
  return (
    <>
      {list &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div className="row" ref={lastBookElementRef} key={item.no}>
                <div className="container-fluid">
                <div className="card border-secondary mt-1">
                    <div className="row ml-1">
                      <div className="container col-xs-12 col-sm-5">
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "15px" }}
                        >
                          <span className="badge badge-pill badge-secondary">
                            {item.no}
                          </span>
                        </div>
                      
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                         {item.name}
                        </div>
                        
                      </div>

                      <div className="container col-xs-12 col-sm-5">
                    
                  

                    
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"status: "}
                             {item.status===true ?  <span className="badge badge-success">{"ปกติ"}</span>:<span className="badge badge-danger">{"ยกเลิก"}</span>}
                          </span>
                        </div>
                      </div>

                      <div className="container col-xs-12 col-sm-2">
                        <div className="d-flex justify-content-end">
                          <div>
                            <button className="btn btn-primary btn-sm m-2"                              
                              onClick={() =>
                              handleOnClick(item._id,item.status)}>
                              <FontAwesome name="edit" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          } else {
            return (
              <div className="row" key={item.no}>
                <div className="container-fluid">
                  <div className="card border-secondary mt-1">
                    <div className="row ml-1">
                      <div className="container col-xs-12 col-sm-5">
                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "15px" }}
                        >
                          <span className="badge badge-pill badge-secondary">
                            {item.no}
                          </span>
                        </div>
                   

                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                           {item.name}
                        </div>
                        
                      </div>

                      <div className="container col-xs-12 col-sm-5">
                       
                      

                        <div
                          className="border border-top-0 border-right-0 border-left-0"
                          style={{ fontSize: "14px" }}
                        >
                          <span style={{ fontSize: "14px" }}>
                            {"status: "}
                             {item.status===true ?  <span className="badge badge-success">{"ปกติ"}</span>:<span className="badge badge-danger">{"ยกเลิก"}</span>}
                          </span>
                        </div>
                      </div>

                      <div className="container col-xs-12 col-sm-2">
                        <div className="d-flex justify-content-end">
                          <div>
                            <button className="btn btn-primary btn-sm m-2"
                            
                            onClick={() =>
                              handleOnClick(item._id,item.status,true)} >
                              <FontAwesome name="edit" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        })}
    </>
  );
};

export default RenderDevice;
